module.exports = __webpack_public_path__ + "img/gwx.66a29705.png";